var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upcoming-events",
      class: {
        container: !_vm.carousel,
      },
    },
    [
      _c(
        "div",
        { staticClass: "upcoming-events-wrapper" },
        [
          _vm.carousel
            ? [_c("upcoming-events-carousel")]
            : [_c("upcoming-events-list")],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }